import React from "react";
import "./KeyFeatures.css";
import img1 from "./img/01.png";
import img2 from "./img/02.png";
import img3 from "./img/03.png";
import img4 from "./img/04.png";
import img5 from "./img/05.png";
import img6 from "./img/06 (1).png";

const features = [
  {
    title: "COURSE COMPLETION CERTIFICATE",
    image: img1,
  },
  {
    title: "HANDS-ON LEARNING",
    image: img2,
  },
  {
    title: "GUEST LECTURES",
    image: img3,
  },
  {
    title: "REAL LIFE-BASED PROJECTS",
    image: img4,
  },
  {
    title: "PLACEMENT OPPORTUNITIES",
    image: img5,
  },
  {
    title: "TEACHER TRAINING PROGRAM",
    image: img6,
  },
];

const KeyFeatures = () => {
  return (
    <section className="features-section">
      <h2 className="features-title">Key Features</h2>
      <div className="features-grid">
        {features.map((feature, index) => (
          <div key={index} className="feature-card">
            <img
              src={feature.image}
              alt={feature.title}
              className="feature-image"
            />
            <h4 className="feature-text">{feature.title}</h4>
          </div>
        ))}
      </div>
    </section>
  );
};

export default KeyFeatures;
